import React from 'react';
import { Facebook, Twitter, Linkedin, Link2, Mail } from 'lucide-react';
import { toast } from 'sonner';

const ShareButtons = ({ url, title, description, className = '' }) => {
  const encodedUrl = encodeURIComponent(url || window.location.href);
  const encodedTitle = encodeURIComponent(title || document.title);
  const encodedDescription = encodeURIComponent(description || '');

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    email: `mailto:?subject=${encodedTitle}&body=${encodedDescription}%0A%0A${encodedUrl}`
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url || window.location.href);
      toast.success('Lien copié !');
    } catch (err) {
      toast.error('Erreur lors de la copie');
    }
  };

  const openShare = (platform) => {
    window.open(shareLinks[platform], '_blank', 'width=600,height=400');
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-stone-500 mr-2">Partager :</span>
      <button
        onClick={() => openShare('facebook')}
        className="p-2 bg-[#1877F2] text-white rounded-full hover:opacity-80 transition-opacity"
        title="Partager sur Facebook"
        aria-label="Partager sur Facebook"
      >
        <Facebook className="w-4 h-4" />
      </button>
      <button
        onClick={() => openShare('twitter')}
        className="p-2 bg-[#1DA1F2] text-white rounded-full hover:opacity-80 transition-opacity"
        title="Partager sur Twitter"
        aria-label="Partager sur Twitter"
      >
        <Twitter className="w-4 h-4" />
      </button>
      <button
        onClick={() => openShare('linkedin')}
        className="p-2 bg-[#0A66C2] text-white rounded-full hover:opacity-80 transition-opacity"
        title="Partager sur LinkedIn"
        aria-label="Partager sur LinkedIn"
      >
        <Linkedin className="w-4 h-4" />
      </button>
      <a
        href={shareLinks.email}
        className="p-2 bg-stone-600 text-white rounded-full hover:opacity-80 transition-opacity"
        title="Envoyer par email"
        aria-label="Envoyer par email"
      >
        <Mail className="w-4 h-4" />
      </a>
      <button
        onClick={copyToClipboard}
        className="p-2 bg-hermes-600 text-white rounded-full hover:opacity-80 transition-opacity"
        title="Copier le lien"
        aria-label="Copier le lien"
      >
        <Link2 className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ShareButtons;
